import React from "react";
import PropTypes from 'prop-types'
import makeStyles from "@material-ui/core/styles/makeStyles";
import Endpoints from "./Endpoints";
import Validations from "./Validations";

const useStyles = makeStyles(() => ({
    apiContainer: {
        height: '100%',
        padding: 15,
        overflow: 'auto'
    }
}));

const Api = (props) => {
    const {
        endpoints, validations,
        onChangeItem, onChangeAll,
        inheritedEndpoints, inheritedValidations, createEndpointEvent, removeEndpointEvent
    } = props;
    const classes = useStyles();
    return (
        <div className={classes.apiContainer}>
                <Endpoints
                    endpoints={endpoints}
                    inheritedEndpoints={endpoints.length ? [] : inheritedEndpoints}
                    onChangeItem={onChangeItem}
                    onChangeAll={onChangeAll}
                    removeEndpointEvent={removeEndpointEvent}
                    createEndpointEvent={createEndpointEvent}
                />
            <Validations
                validations={validations}
                inheritedValidations={validations.length ? [] : inheritedValidations}
                onChangeItem={onChangeItem}
                onChangeAll={onChangeAll}
            />
        </div>
    )
};
export default Api

Api.propTypes = {
    endpoints: PropTypes.array,
    validations: PropTypes.array,
    onChangeItem: PropTypes.func,
    onChangeAll: PropTypes.func,
    inheritedEndpoints: PropTypes.array,
    inheritedValidations: PropTypes.array
};

Api.defaultProps = {
    endpoints: [],
    validations: []
};